export const formatCurrency = (amount: number): string => {
  const formatter = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${formatter.format(amount)} TL`;
};
